import type { ApprovedFundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { TRAINING_ITEM_TYPE } from "@academy-context/shared/domain/types/training-items";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveApprovedFundingRequests = createApiThunk<
  ApprovedFundingRequestVM[],
  { funders?: string[]; trainingItemTypes?: TRAINING_ITEM_TYPE[] } | undefined
>(
  "fundingRequests/retrieveApprovedFundingRequests",
  async (filters: { funders?: string[]; trainingItemTypes?: TRAINING_ITEM_TYPE[] } | undefined, { extra: { adminRepository } }) => {
    const requests = await adminRepository!.getAll({
      status: ["approved"],
      funders: filters?.funders,
      trainingItemTypes: filters?.trainingItemTypes,
    });
    const response: ApprovedFundingRequestVM[] = [];
    for (const r of requests) {
      if (r.status === "approved") {
        response.push(r);
      }
    }
    return response;
  },
);
